import React from 'react';
import { bool, string } from 'prop-types';

// components
import { Box, Typography } from '@mui/material';
import { ProductIndicatorBadge } from 'common';

const SupplierAuthCardHeader = ({ proprietary, subtitle, title }) => (
  <Box display="flex" justifyContent="space-between" mb={0.5}>
    <Box>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2">{subtitle}</Typography>
    </Box>
    <Box display="flex">
      <ProductIndicatorBadge proprietary={proprietary} />
    </Box>
  </Box>
);

export default SupplierAuthCardHeader;

SupplierAuthCardHeader.propTypes = {
  proprietary: bool,
  subtitle: string,
  title: string,
};

SupplierAuthCardHeader.defaultProps = {
  proprietary: null,
  subtitle: '',
  title: '',
};
